import { environment } from '../../../../environments/environment';
import { ENDPOINTS_EXCLUDED_FROM_JWT_TOKEN_REFRESH } from '../../consts/auth.consts';

const getPathname = (url: string): string => {
  try {
    return new URL(url, globalThis.location.origin).pathname;
  } catch {
    return url;
  }
};

export const isUrlExcludedFromJwtTokenRefresh = (url: string): boolean => {
  const normalizedRequestPathname = getPathname(url);

  return ENDPOINTS_EXCLUDED_FROM_JWT_TOKEN_REFRESH.some(({ apiName, path }) => {
    return (
      getPathname(`${environment[apiName].endpoint}${path}`) ===
      normalizedRequestPathname
    );
  });
};
